import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface PageHeaderProps {
  title: ReactNode;
  /** One line under the title explaining what the page is for (brief §6). */
  subtitle?: ReactNode;
  /** Right-aligned controls — buttons, segmented toggles… */
  actions?: ReactNode;
  /** A back link / breadcrumb rendered above the title. */
  back?: ReactNode;
  /** Leading element (avatar, icon tile) beside the title block. */
  leading?: ReactNode;
  size?: 'md' | 'lg';
  className?: string;
}

/** The one page-title row every portal page opens with: title + one-line
 *  explanation on the left, actions on the right, stacking on phones. */
export function PageHeader({ title, subtitle, actions, back, leading, size = 'md', className }: PageHeaderProps) {
  return (
    <div className={cx('tc-page-header', size === 'lg' && 'tc-page-header--lg', className)}>
      {back && <div className="tc-page-header__back">{back}</div>}
      <div className="tc-page-header__row">
        {leading && <div className="tc-page-header__leading">{leading}</div>}
        <div className="tc-page-header__text">
          <h1 className="tc-page-header__title">{title}</h1>
          {subtitle && <p className="tc-page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="tc-page-header__actions">{actions}</div>}
      </div>
    </div>
  );
}
